/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autonomous_Shopping_And_InquirInputs */

const en_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomous shopping and inquiry assistance`)
};

const es_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistencia autónoma de compras y consultas`)
};

const fr_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance autonome pour les achats et les demandes`)
};

const de_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonome Shopping- und Anfrage-Assistenz`)
};

const ja_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自律的なショッピングおよび問い合わせアシスト`)
};

const zh_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自主购物与咨询辅助`)
};

const ar_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساعدة مستقلة في التسوق والاستفسارات`)
};

const id_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bantuan belanja dan pertanyaan otonom`)
};

const it_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistenza autonoma per gli acquisti e le richieste`)
};

const ru_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автономные продажи и обработка запросов`)
};

const pt_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistência autônoma de compras e consultas`)
};

const ko_autonomous_shopping_and_inquir = /** @type {(inputs: Autonomous_Shopping_And_InquirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자율적인 쇼핑 및 문의 지원`)
};

/**
* | output |
* | --- |
* | "Autonomous shopping and inquiry assistance" |
*
* @param {Autonomous_Shopping_And_InquirInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const autonomous_shopping_and_inquir = /** @type {((inputs?: Autonomous_Shopping_And_InquirInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autonomous_Shopping_And_InquirInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autonomous_shopping_and_inquir(inputs)
	if (locale === "es") return es_autonomous_shopping_and_inquir(inputs)
	if (locale === "fr") return fr_autonomous_shopping_and_inquir(inputs)
	if (locale === "de") return de_autonomous_shopping_and_inquir(inputs)
	if (locale === "ja") return ja_autonomous_shopping_and_inquir(inputs)
	if (locale === "zh") return zh_autonomous_shopping_and_inquir(inputs)
	if (locale === "ar") return ar_autonomous_shopping_and_inquir(inputs)
	if (locale === "id") return id_autonomous_shopping_and_inquir(inputs)
	if (locale === "it") return it_autonomous_shopping_and_inquir(inputs)
	if (locale === "ru") return ru_autonomous_shopping_and_inquir(inputs)
	if (locale === "pt") return pt_autonomous_shopping_and_inquir(inputs)
	return ko_autonomous_shopping_and_inquir(inputs)
});